// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"dc8cfa7b111c30e1","4439":"b1c36100a49656b7","5801":"f46de35ae5defc38","7744":"6b03d7aa6971c2d4","7746":"917fff2080cbd79c","9591":"d3c95a37ae87734f","9860":"ecac374cca0779f6"}[chunkId] + ".1783593032981.js";
};